import { v4 } from 'uuid';
import { BROWSER_SESSION_ID_ITEM } from '../constants';
import { getContext } from './contextManager';
import { Logger } from '@chargeafter/logger';
import { environment } from '../environment';

type LoggerLogArgs = {
  function: string;
  filename: string;
  [key: string]: unknown;
};

const initBrowserSessionId = () => {
  const browserSessionId = v4();
  sessionStorage.setItem(
    BROWSER_SESSION_ID_ITEM,
    JSON.stringify(browserSessionId),
  );
  return browserSessionId;
};

const logging: Logger = new Logger({
  production: environment.envName === 'production',
  logsUrl: environment.logsUrl as string,
  appName: 'StoreApp',
  browserSessionId: initBrowserSessionId(),
});

const logger = {
  log: (msg: string, args: LoggerLogArgs) =>
    logging.log(msg, {
      ...args,
      context: getContext(),
    }),
  error: (msg: string, args: LoggerLogArgs) =>
    logging.error(msg, {
      ...args,
      context: getContext(),
      navigatorData: {
        appCodeName: navigator.appCodeName,
        appName: navigator.appName,
        appVersion: navigator.appVersion,
        cookieEnabled: navigator.cookieEnabled,
        language: navigator.language,
        languages: navigator.languages,
        onLine: navigator.onLine,
        platform: navigator.platform,
        product: navigator.product,
        productSub: navigator.productSub,
        serviceWorker: {
          controller: navigator.serviceWorker.controller,
          ready: navigator.serviceWorker.ready,
        },
        userAgent: navigator.userAgent,
        vendor: navigator.vendor,
        vendorSub: navigator.vendorSub,
      },
    }),
  warn: (msg: string, args: LoggerLogArgs) =>
    logging.warn(msg, {
      ...args,
      context: getContext(),
    }),
};

export default logger;
